<template>
	<div class="stroeGoods">
        <Qrcode-Dialog :openQueHuochuankao.sync="openQueHuochuankao"  @createPurOrder="tocaiguo"/>
		<Qrcode-Dialog :showSales.sync="showSales" :salesItem="salesItem"/>
		<Qrcode-Dialog :instockdia.sync="instockdia" />
		<Table-Dialog  :showTable.sync="showTable" @getShopItem="getShopItem" @giveItem="giveItem"></Table-Dialog>
		<Table-Dialog  :bindInfo.sync="bindInfo"  :p_sku_Info="p_sku_Info"></Table-Dialog>
		
		<el-dialog :title="$t('userStoreItems').bindItem.title" :visible.sync="dialogTableVisible" width="80%">
			<div class="xinzhen"><el-button size="medium" type="primary" @click="goBindproduct">{{$t('userStoreItems').bindItem.xinzhen}}</el-button></div>
			<el-table :data="bindItemList01" height="250px" >
				<el-table-column width="80" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src="changeImgURL(scope.row)" alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('userStoreItems').bindItem.shopName"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.shopName}} ({{platform(scope.row.shopee)}})</span>
					</template>
				</el-table-column>
				<el-table-column property="name" :label="$t('userStoreItems').bindItem.anthreName"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="itemSku" label="sku"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{conversionSku(scope.row)}}</span>
					</template>
				</el-table-column>
				<el-table-column property="itemSku" :label="$t('other.a1348')"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{ scope.row.isPreOrder ? $t('other.a191') : $t('other.a192')}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a3006')" width="200px"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-switch
						v-show="scope.row.shopee"
						@change='autoPre(scope.row)'
						v-model="scope.row.isAutoPre"
						:active-text="$t('other.a191')"
						:inactive-text="$t('other.a192')">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column   :label="$t('other.a2920') width="200px"  >
					<template slot-scope="scope">
						<span v-show="!scope.row.setPresale">{{scope.row.preDay}}</span>
						<el-input v-if="scope.row.setPresale" style="width: 80px;" size="mini"   v-model="scope.row.preDay" ></el-input>
						<i v-show="!scope.row.setPresale && scope.row.isAutoPre" class="el-icon-edit" @click="scope.row.setPresale=true"></i>
						<span style="margin-left: 12px;cursor: pointer;color: red;" v-show="scope.row.setPresale" @click="fixPresale(scope.row)">{{$t('other.a38')}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a2456')" width="200px"  >
					<template slot-scope="scope">
						<span v-show="!scope.row.setRate">{{scope.row.hasVariation ? scope.row.variation.rate :scope.row.rate}}</span>
						<el-input-number v-if="scope.row.setRate && scope.row.hasVariation" style="width: 120px;" size="mini" :min="1"  v-model="scope.row.variation.rate" ></el-input-number>
						<el-input-number v-if="scope.row.setRate && !scope.row.hasVariation" style="width: 120px;" size="mini" :min="1"  v-model="scope.row.rate" ></el-input-number>
						<i v-show="!scope.row.setRate" class="el-icon-edit" @click="scope.row.setRate=true"></i>
						<span style="margin-left: 12px;cursor: pointer;color: red;" v-show="scope.row.setRate" @click="fixRate(scope.row)">{{$t('other.a38')}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('userStoreItems').bindItem.operate"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-button type="danger" @click="jiebang(scope.row)">{{$t('userStoreItems').bindItem.jieban}}</el-button>
					</template>
				</el-table-column>
				
			</el-table>
			<div style="font-size: 18px;margin: 20px 0;display: flex;justify-content: space-between;">
				<div>
					({{$t('other.a3007')}}){{$t('other.a3008')}} ({{bindItemList02.length}})
					<el-tooltip class="item" effect="dark"  placement="top-start">
						<div style="font-size: 18px;" slot="content">
							{{$t('other.a3009')}}
						</div>
					     <i class="el-icon-question oook"></i>:
					    </el-tooltip>
				</div>
				<div>
					 <el-button v-show="!isEditGoods" type="primary" @click="editorSuscode">{{$t('other.a238')}}</el-button>
					<!-- <el-button v-show="isEditGoods" type="danger" @click="editorSuscode">{{$t('other.a38')}}</el-button> -->
					 <el-button v-show="isEditGoods" type="primary" @click="addGoods">{{$t('other.a3010')}}</el-button>
					 <el-button v-show="isEditGoods" type="primary" @click="saveItems">{{$t('other.a216')}}</el-button>
				</div>
			</div>
			<el-table :data="bindItemList02" height="250px" >
				<el-table-column width="80" :label="$t('other.a66')" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src="changeImgURL(scope.row)" alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column width="200" :label="$t('other.a67')" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<!-- <el-input v-model="scope.row.cusCode" ></el-input> -->
						<span>{{scope.row.cusCode}}</span>
					</template>
				</el-table-column>
				<el-table-column width="250" label="sku" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<!-- <el-input v-model="scope.row.skuName" ></el-input> -->
						<span>{{scope.row.skuName}}</span>
					</template>
				</el-table-column>
				<el-table-column width="80" :label="$t('other.a2456')" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<el-input v-show="isEditGoods" v-model="scope.row.rate" ></el-input>
						<span v-show="!isEditGoods">{{scope.row.rate == 0 ? 1 : scope.row.rate}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a33')" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<!-- <span v-show="isEditGoods" style="margin-right:15px;color: red;cursor: pointer;">{{$t('other.a93')}}</span> -->
						<span v-show="isEditGoods" style="margin-right:15px;color: red;cursor: pointer;" @click="deletGoods(scope.row)">{{$t('other.a312')}}</span>
					</template>
				</el-table-column>
				
			</el-table>
		</el-dialog>
		
		<el-dialog :title="$t('userStoreItems').update.tip"  :visible.sync="dialogVisible01" width="30%" >
			<p class="visiableMessage_desc">{{visiableMessage}}</p>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" v-if=" isCloseUpdataBtn" @click="dialogVisible01=false;isCloseUpdataBtn=false">{{$t('userStoreItems').update.open}}</el-button>
				<el-button size="mini" type="primary" v-if="isCloseUpdataBtn" @click="closeUpdate">{{$t('userStoreItems').update.close}}</el-button>
				<el-button size="mini" type="primary" v-if="isOpenUpdataBtn" @click="closeUpdate_01">{{$t('userStoreItems').update.close01}}</el-button>
				<el-button size="mini" type="primary" v-if="isOpenUpdataBtn " @click="openUpdate">{{$t('userStoreItems').update.open01}}</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="$t('userStoreItems').Prompt" :visible.sync="dialogVisible" width="30%">
			<span>{{visiableMessage}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">{{$t('userStoreItems').ok}}</el-button>
			</span>
		</el-dialog>
		<!-- 自动关联绑定详情 -->
		<el-dialog :title="$t('binditems').details.title" :visible.sync="TppCopy" center width="80%">
			<div class="quit-wapper">
				<span class="quit-wrapper-item">{{$t('binditems').details.success}}({{bindSuccess.length}})</span>
				<span class="quit-wrapper-item">{{$t('other.a1910')}}({{bindError.length}})</span>
			</div>
			<div class="quit-box" >
				<el-table style="margin-left: 10px;" :data="bindSuccess" height="350px" border>
					<el-table-column property="name" :label="$t('binditems').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="name" :label="$t('binditems').details.name" width="250" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="itemSku" :label="$t('binditems').details.SKU"  :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('binditems').details.cusCode"   :show-overflow-tooltip="true">
					</el-table-column>
					
				</el-table>
				<el-table style="margin-left: 10px;" :data="bindError" height="350px" border>
					<el-table-column property="name" :label="$t('binditems').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="scope.row.image" style="width: 150px;height: 150px" />
								<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="bindMsg" :label="$t('other.a677')"  :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
			</div>
			<div class="ttp-uu">
				<el-button @click="TppCopy=false" type="primary">{{$t('binditems').details.ok}}</el-button>
			</div>
			
		</el-dialog>
		
	    <!-- 入库单 -->
		<el-dialog :title="$t('other.a511')" :visible.sync="caigouTable" center width="80%">
			<div style="display: flex;margin-bottom: 10px;align-items: center;">
				<div class="block">
				{{$t('other.a2120')}}：<el-date-picker
					size="small"
					style="width: 250px;"
					v-model="value1"
					type="date"
					:placeholder="$t('other.a2123')">
				</el-date-picker>
				</div>
				
				<div style="margin-left: 20px; font-size: 18px;">{{$t('other.a2122')}}：{{calTotal}}</div>
			</div>
			<div style="margin:5px 0">
				{{$t('other.a2103')}}：<el-input style="width: 250px;" onkeyup="value=value.replace(/[^\d\.]/g,'')" @blur='showPrice=false' @focus="showPrice=true" size="small" v-model="shipCost" :placeholder="$t('other.a2106')"></el-input>
			    <span v-show="showPrice" style="margin-left:15px;color:red">{{$t('other.a2121')}}</span>
			</div>
			<div style="padding:5px 0">
				{{$t('other.a3011')}}：
				<!-- <el-switch
					v-model="Fbs"
					@change="getFibs()"
					:active-text="$t('other.a191')"
					:inactive-text="$t('other.a192')">
				</el-switch> -->
			</div>
			<div style="margin-bottom:20px" v-if="Fbs">
				 <el-table
				 size="mini"
				 height="100"
				 ref="multipleTable"
				 :data="tableData"
				style="width: 100%">
				 <el-table-column
				
				width="55">
				 <template scope="scope">
					 <el-checkbox v-model="scope.row.checked" @change="handleSelectionChange(scope.row)"></el-checkbox>
					
				</template>

				</el-table-column>
				<el-table-column
			        prop="country"
			        :label="$t('other.a481')"
			        width="80">
					<template slot-scope="props">
						<span>{{props.row.country}}</span>
					</template>
			      </el-table-column>
			      <el-table-column
			        prop="goodType"
			        :label="$t('other.a775')"
			       >
					<template slot-scope="props">
						<span>{{showStore(props.row.goodType) }}</span>
					</template>
			      </el-table-column>
			      <el-table-column
			        prop="feeType"
			        :label="$t('other.a2130')"
					
					>
					<template slot-scope="props">
						<span>{{props.row.fee}}/{{props.row.feeType == 1 ? $t('other.a2133') : props.row.feeType == 2 ? $t('other.a2134') : $t('other.a2135')}}</span>
					</template>
			      </el-table-column>
				  <el-table-column
				    :label="$t('other.a3012')"
					>
					<template slot-scope="props">
						<span>{{totalWeight}}/KG</span>
					</template>
				  </el-table-column>
				  <el-table-column
				    prop="phone"
				    :label="$t('other.a3013')"
					>
					<template slot-scope="props">
						<span>{{totalVolume}}/{{$t('other.a1513')}}</span>
					</template>
				  </el-table-column>
				  <el-table-column
				    prop="address"
				    :label="$t('other.a2132')">
					<template slot-scope="props">
						<span>{{totalVolume* props.row.fee}}</span>
					</template>
				  </el-table-column>

				  
				</el-table>
			</div>
			<div style="height: 400px;">
				<el-table :data="isChooseList" height="70%" border>
					<el-table-column property="name" :label="$t('userStoreItems').caigou.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="scope.row.image" style="width: 150px;height: 150px" />
								<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="itemName" :label="$t('userStoreItems').caigou.name" width="200" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column property="skuName" label="sku"  :show-overflow-tooltip="true"></el-table-column>
					<el-table-column :label="$t('other.a1126')" v-if="show">
						<template scope="scope">
							<el-input  size="mini" :step="1" v-model="scope.row.cost"></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a2108')">
						<template scope="scope">
							<el-input-number  size="mini" :min="1" v-model="scope.row.num" ></el-input-number> 
						</template>
					</el-table-column>
					<el-table-column :label="$t('userStoreItems').caigou.anthreName">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.anotherName" clearable></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a2107')">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.totalVolume" clearable></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="$t('userStoreItems').caigou.operate" >
						<template scope="scope">
							<el-button type="text" size="mini" @click="deleteChoose(scope.row,scope.$index)" style="width: 70px;">{{$t('userStoreItems').caigou.dele}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div>
					<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :placeholder="$t('userStoreItems').caigou.tip" v-model.lazy="sellerMessage"
					 resize="none">
					</el-input>
				</div>
				<div style="float: right;margin: 15px;">
					<el-button @click="cleanForm">{{$t('userStoreItems').caigou.qingkong}}</el-button>
					<el-button @click="createOrder" type="primary">{{$t('other.a3014')}}</el-button>
				</div>
			</div>
		</el-dialog>
		<div class="header-top">
			<div style="margin: 20px 0;">
				<span style="margin-right: 20px;font-size: 18px;" @click="resetPage">{{itemsCount}} {{$t('userStoreItems').ppo}}</span>
			    <!-- <el-button size="medium" type="primary" @click="ttp"><i class="iconfont  icon-shuaxin2 "></i>{{$t('other.a1673')}}</el-button> -->
			</div>
			<!-- 一级菜单栏 -->
			<div class="query-list">
				
				<div class="query-list-tcp">
					<div style="width: 150px;">
						<el-select @change="getShopItems(warehouseId)" v-model="warehouseId" :placeholder="warehouseOption[0].value" >
							<el-option v-for="item in warehouseOption" :key="item.storeId" :label="item.value" :value="item.label">
							</el-option>
						</el-select>
					</div>
					<div class="query-list-bbc create">
						<el-input style="width: 260px;margin-right: 5px;" clearable  :placeholder="$t('userStoreItems').search_tip" v-model="cusCode"></el-input>
						<el-button  type="primary" @click="goTosearch()">{{$t('userStoreItems').search}}</el-button>
					</div>
				</div>
				<div class="query-list-tcp">
					<!-- <div class="create">
						<el-button type="primary" @click="openopenQueHuotixing" size="small">{{$t('userStoreItems.quehuo')}}</el-button>
						<span class="cirlle">{{xuehuoInfocount}}</span>
					</div> -->
					<div class="create" v-show="!isBindItemModel">
						<el-button type="primary" @click="tocaiguo">{{$t('userStoreItems').Generate_warehouse_items}}</el-button>
						<span class="cirlle">{{count}}</span>
					</div>
				</div>
			</div>
			<!-- 二级菜单栏 -->
			<div class="query-list-tcp">
				
			</div>
		</div>
		<div class="mygoods-list">
			<div class="mygoods-list-nodata" v-if="!newUserstoreItem.length " >--{{$t('userStoreItems').nodata}}--</div>
			<div class="my-goods-data" v-else>
				<div v-for="(outeritem,index) in newUserstoreItem" :key="index" >
					<div class="list-item">
						<el-row>
							<el-col :span="24">
								<div style="border-bottom: 1px solid #E0E0E0;">
									<div class="outPsku">
										<div style="display: flex;">
											<span style="color: orangered;display: inline-block;max-width: 450px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
											 {{$t('other.a2145')}}：
											 <span v-show="!outeritem.checked01">{{outeritem.itemSku}}</span>
											</span>
										</div>
										<div style="display: flex;">
											<div style="font-size: 14px;font-weight: initial;margin-right: 20px;">{{$t('other.a57')}}：{{getTime01(outeritem.createTime)}}</div>
											<div style="font-size: 16px;font-weight: initial;margin-right: 20px;cursor: pointer;" >
												<el-button  type="primary" @click="outeritem.checked02=!outeritem.checked02">{{$t('other.a2146')}}/{{$t('other.a2147')}}</el-button>
											</div>
											<div style="margin-right: 5px;">
												 <el-button v-show="!outeritem.checked03" type="primary" @click="getALLitems(outeritem)">{{$t('other.a2148')}}</el-button>
												 <el-button v-show="outeritem.checked03" type="danger" @click="getALLitems(outeritem)">{{$t('other.a3015')}}</el-button>
											</div>
										</div>
									</div>
									<div style="display: flex;justify-content: space-between;box-sizing: border-box;padding: 10px 10px 10px 20px;">
										<div style="display: flex;">
											<div class="goods-pic"><img v-image-preview :src="outeritem.storeItems ? outeritem.storeItems[0].image : ''"></div>
											<div style="width: 300px;margin-left: 20px;">{{outeritem.storeItems ? outeritem.storeItems[0].itemName : ''}}</div>
											<div style="width: 300px;margin-left: 20px;">{{$t('other.a660')}}：{{outeritem.storeItems ? outeritem.storeItems.length : 0 }}</div>
										</div>
									</div>
								</div>
								<div v-if="outeritem.checked02" v-for="(item,index) in outeritem.storeItems" :key="index">
									<div class="item-view">
										<div class="goods-desc">
											<div class="goods-title-desc-wrapper">
												<div class="goods-title-desc-box">
													<div style="font-size: 16px;color: red;padding-bottom: 5px;" v-if="isEdit !== index">{{$t('other.a2139')}}：{{item.skuName}}</div>
													<div v-else>
														{{$t('other.a2139')}}：
														<el-input size="mini" style="width: 200px;;"
															  v-model="item.skuName"
															  :rows="2"
															  type="textarea"
															  autosize="autosize"
															  >
														</el-input>
													</div>
													<div class="goods-item-a">{{$t('userStoreItems').cusCode}}：{{item.cusCode}}</div>
													<div class="goods-item-a">{{$t('userStoreItems').shop}}：{{item.shopName}}</div>
													<div class="goods-item-a">{{$t('userStoreItems').userName}}：{{item.userName}}</div>
													<div class="goods-item-a">{{$t('userStoreItems').warehouse}}：{{item.storeName}}</div>
													<div class="goods-item-a" v-if="show">
														<div v-if="isEdit !== index">{{$t('userStoreItems').cost}}：{{item.cost}}</div>
														<div v-else>
															{{$t('userStoreItems').cost}}：
															<el-input size="mini" style="width: 80px;;"
																  v-model="item.cost"
																  >
															</el-input>
														</div>
													</div>
												</div>
												<div class="goods-title-desc-box">
													<div class="goods-item-a">
														{{$t('userStoreItems.Quantitytobeshipped')}}：{{item.auditedStock}}
													</div>
													<div class="goods-item-a">
													     {{$t('userStoreItems').shipping_stock}}：{{item.unShipped}}
													</div>
													<div class="goods-item-a">
														{{$t('userStoreItems').online_stock}}：{{item.stock}}
													</div>
													<div class="goods-item-a">
														{{$t('other.a2540')}}：{{item.reservedStock}}
													</div>
													<div class="goods-item-a">{{$t('userStoreItems').total_stock}}：{{item.storeNum}}</div>
													
												</div>
												<div class="goods-title-desc bbp">
													<div class="goods-item-a">
														<div v-if="isEdit !== index">{{$t('userStoreItems.long')}}：{{item.packageLength ? item.packageLength : 0}} cm</div>
														<div v-else>
															{{$t('userStoreItems.long')}}：
															<el-input size="mini" style="width: 80px;;"
																  v-model="item.packageLength"
																  >
															</el-input>
														</div>
													</div>
													<div class="goods-item-a ">
													     <div v-if="isEdit !== index">{{$t('userStoreItems.width')}}：{{item.packageWidth ? item.packageWidth : 0}} cm</div>
													     <div v-else>
													     	{{$t('userStoreItems.width')}}：
													     	<el-input size="mini" style="width: 80px;;"
													     		  v-model="item.packageWidth"
													     		  >
													     	</el-input>
													     </div>
													</div>
													<div class="goods-item-a">
														 <div v-if="isEdit !== index">{{$t('userStoreItems.height')}}：{{item.packageHeight ? item.packageHeight : 0}} cm</div>
														 <div v-else>
														 	{{$t('userStoreItems.height')}}：
														 	<el-input size="mini" style="width: 80px;;"
														 		  v-model="item.packageHeight"
														 		  >
														 	</el-input>
														 </div>
													</div>
													<div class="goods-item-a">
													<div v-if="isEdit !== index">{{$t('userStoreItems.weight')}}：{{item.weight ? item.weight : 0}} kg</div>
													<div v-else>
														{{$t('userStoreItems.weight')}}：
														<el-input size="mini" style="width: 80px;;"
															  v-model="item.weight"
															  >
														</el-input>
													</div>
													</div>
												</div>
											</div>
										</div>
										<div class="btn-wrapper">
											<div class="btn-item-desc" v-show="!isBindItemModel">
												<el-button style="width: 120px;" :type="item.checked ? 'danger' : 'primary'"  @click="targetVariation(item,null)"  >{{item.checked ? $t('other.a2144') : $t('other.a1334') }}</el-button>
											</div>
										</div>
									</div>
								</div>
								
							</el-col>
						</el-row>
						
					</div>
				</div>
				<!-- 分页器 -->
				<div class="Pager">
				    <el-pagination
				      @size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[15, 20, 30, 100]"
					:page-size="15"
					layout="total, sizes, prev, pager, next, jumper"
					:total="itemsCount">
				    </el-pagination>
				  </div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import api from '../../api/api.js'
	import utils from '../../utils/utils.js'
	import mygoods from '../../api/moudles/mygoods.js'
	import XLSX from 'xlsx'
	import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
	import TableDialog from './components/table.vue'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				warehouse: JSON.parse(localStorage.getItem('warehouse')),
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				warehouseOption:[],
				warehouseId: '',
				chosedStore: '',
				shipCost:'',
				itemNameQuery: '',
				statusValue: '',
				isChooseList: [],
				bindItemList: [],
				caigouTable: false,
				bindTable: false,
				count: 0,
				totalPont:null,
				dialogVisible: false,
				remindDialog: false,
				itemCount: 0,
				arr: [],
				isBindItemModel: false,
				sellerMessage: "",
				visiableMessage: '',
				stockRemindList: [],
				remindCount: 0,
				selectShop: '',
				currentPage:0,
				isPresale:false,
				offset:15,
				isEdit:-1,
				secondPws:'',
				commfire:true,
				dialogTableVisible:false,
				autosize:{
					minRows: 2
				},
				cusCode:'',
				showTable:false,
				valueoop: true,
				textUpdate:" ",
				fbsId:null,
				dialogVisible01:false,
				oooop:{},
				showPrice:false,
				cuscodeBand:null,
				tragetList:[],
				checked_01:false,
				isOpenUpdataBtn:false,
				isCloseUpdataBtn:false,
				value1: '',
				openQueHuochuankao:false,
				showSales:false,
				salesItem:null,
				instockdia:false,
				bindItemList01:[],
				bindItemList02:[],
				limitNum: 1,
				fileList: [],
				options: [{
				  value: 0,
				  label: this.$t('other.a2243')
				}, {
				  value: 1,
				  label: this.$t('other.a2244')
				},{
				  value: 2,
				  label: this.$t('other.a2245')
				},{
				  value: 3,
				  label: this.$t('other.a2246')
				},{
				  value: 4,
				  label: this.$t('other.a2247')
				},{
				  value: 5,
				  label: this.$t('other.a2248')
				},],
				tableData:[],
				chooseStoreId:null,
				setRate:false,
				targetList:[],
				isEditGoods:false,
				bindInfo:false,
				showTTp:false,
				p_sku_Info:null,
				Fbs:true,
				TppCopy:false,
				bindSuccess:[],
				bindError:[],
				multipleSelection:[],
				descText:this.$t('other.a3016')
				
			
				
				
				       
			}
		},
		components: {
			QrcodeDialog,
			TableDialog
		},
		
		computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userStormList: state => state.userStoreItems.userStormList,
				itemsCount: state => state.userStoreItems.itemsCount,
				// bindItemList01: state => state.userStoreItems.bindItemList01,
				deleTip: state => state.userStoreItems.deleTip,
				deletSuccess: state => state.userStoreItems.deletSuccess,
				getDateSuccess:state => state.userStoreItems.getDateSuccess,
				xuehuoInfo:state => state.userStoreItems.xuehuoInfo,
				xuehuoInfocount:state => state.userStoreItems.xuehuoInfocount,
				secondPassword:state=>state.shopaccess.secondPassword,
				newUserstoreItem:state=>state.userStoreItems.newUserstoreItem,
				refresh:state=>state.userStoreItems.refresh,
				
			}),
			
			
			
	
			
			show(){
				return  this.secondPassword
			},
			calTotal(){
				let num=0
				this.isChooseList.forEach(p => {
					num=parseInt(p.num) + num
				})
				return num
			},
			
		
			remindList() {
				return this.stockRemindList;
			},

			totalVolume(){
					
				console.log(this.isChooseList)
			    let totalVolumeHeigh=0
				this.isChooseList.forEach(p =>{
					p.totalVolume= p.packageHeight*p.packageLength*p.packageWidth*Number(p.num)/1000000
				
					totalVolumeHeigh += p.packageHeight*p.packageLength*p.packageWidth
					totalVolumeHeigh=totalVolumeHeigh*Number(p.num)
				

				})
				let total=0
				this.isChooseList.forEach(p => {
					total += p.totalVolume
				})

				console.log(totalVolumeHeigh)
				console.log(total)

				return total
			},
			totalWeight(){
				console.log(this.isChooseList)
			    let totalWeight=0
				this.isChooseList.forEach(p =>{
					totalWeight += p.weight*Number(p.num)
				})
				console.log(totalWeight)
				return totalWeight
			}
			
			
		},
		watch:{
			newUserstoreItem(){
				return this.newUserstoreItem.forEach(p => {p.checked02=true})
			},
				

			dialogVisible(){
				if(!this.dialogVisible){
					this.resetPage()
				}
			},
		
			refresh(){
				if(this.refresh){
					this.checked_01=false
					this.targetList=[]
					setTimeout(() => {
						this.ttp()
					},1000)
				}
			},
			cusCode(){
				if(this.cusCode === "")
				this.getShopItems()
			},
			deletSuccess(){
				if(this.deletSuccess === "success") {
					this.open2(this.$t('other.a3017'))
				}else if(this.deletSuccess === "failed") {
					this.open3(this.$t('other.a3018'))
				}
			},
			getDateSuccess(){
				if(this.getDateSuccess) {
					this.getShopItems001()
				}
			}
			
			
			
		},
		created(){
			this.ttp()
			
		},
		methods: {
			...mapActions('userStoreItems', [
				'getStoreItem',
				'createCaiGouTable',
				'viewBindItems',
				'deleStoreItems',
				'jiebanItems',
				'updateItemInfo',
				'updateStoreItem',
				'updateShopeeItemStock',
				'sellerUpdateStoreItemDetail',
				'sellerUpdateSynchrony',
				'isAutoPre',
				'getStockRemind',
				'getStoreSales',
				'getStoreProductInventoryTurnover',
				'getInstockoperaterecore',
				'fileUpload',
				'updatRate',
				'deleteGroup',
				'updateGroup',
				'updateIsAutoPre',
				'getTableList',
				'updateBindStoreItem',
				'viewBindInfo',
				'getRuler'
				
				]),
				...mapActions('mygoods', [
					'bindBYsku'
					]),
					
				...mapMutations('userStoreItems', [
					'TARGET_ALL',
					'GET_DATA_STATUS_COLSE',
					'KEEP_CHOOSED_ITEM'
				]),
				
				openItems(num){
					if(num == 0) {
						this.newUserstoreItem.forEach(p => {p.checked02=true})
					}else{
						this.newUserstoreItem.forEach(p => {p.checked02=false})
					}
				},

				resetPage(){
					console.log('newUserstoreItem',this.newUserstoreItem)
					this.newUserstoreItem.forEach(p => {
						p.storeItems.forEach(k => {
							k.checked=false
						})
					})
				},
				
				getBindGoods(item){
					this.bindInfo=true
					this.p_sku_Info=item
					this.viewBindInfo({groupId:item.groupId})
				},
				
				editorSuscode(){
					this.isEditGoods=!this.isEditGoods
				},
				
				getShopItem(data){
					const params={
						offset:data.offset,
						page:data.page,
						userId:this.userId,
						storeId:'',
						sellerId:this.userId,
						cusCode:data.cusCode
					}
					this.showTable=true
					this.getTableList(params)
				},
				
				
				giveItem(data){
					console.log(data)
					let list = data.list
					let arr=[]
					let obj={}
					console.log(list)
					console.log(this.bindItemList02)
					list.forEach(p => {
						this.bindItemList02.push(p)
					})
					
					this.bindItemList02.forEach(p => {
						if(!obj[p.cusCode]) {
							arr.push(p)
							obj[p.cusCode] = true
						}
					})
					this.bindItemList02=arr
					
					
				},
				
				deletGoods(item){
					this.bindItemList02.forEach((p,index) => {
						if(p.cusCode == item.cusCode && p.itemId == item.itemId){
							this.bindItemList02.splice(index,1)
						}
					})
				},
				
				saveItems(){
					this.isEditGoods=!this.isEditGoods
					let arr=this.bindItemList02.map(p => {
						return {
							childrenId:p.cusCode,
							parentId:this.cuscodeBand,
							rate:p.rate
						}
					})
					let params={
						binds:arr,
						parentId:this.cuscodeBand
					}
					console.log(this.bindItemList02)
					console.log(params)
					this.updateBindStoreItem(params)
				},
				
				addGoods(){
					console.log(5241)
					const params={
						offset:this.offset,
						page:this.currentPage,
						userId:this.userId,
						storeId:'',
						sellerId:this.userId,
						cusCode:''
					}
					this.showTable=true
					this.getTableList(params)
				},
				
				massDeletd(){
					let arr=this.targetList.map(p => {
						return {
							groupId:p.groupId
						}
					})
					console.log(arr)
					if(arr.length ==0) {
						this.$message.error(this.$t('other.a3019'))
						return
					}
					this.deleteGroup(arr)
					this.newUserstoreItem.forEach(p => {
						p.checked=false
					})
					console.log(arr)
				},
				
				getPsku(item){
					this.newUserstoreItem.forEach(p => {
						if(p.groupId == item. groupId&&   p.itemSku == item.itemSku){
							p.checked=item.checked
						}
					})
					this.targetList=this.newUserstoreItem.filter(p => {
						if(p.checked){
							return p
						}
					})
					console.log('选中',this.targetList)
				},
				
				deleteGroupTpp(id){
					this.deleteGroup([{groupId:id}])
				},
				
				
				toBind(id,sku){
					console.log(id)
					this.$router.push({path:'./binditems',query:{groupId:id,itemSku:sku}})
				},
				
				autoBind(groupId){
					
					
					mygoods
					.bindBYsku({groupId})
					.then(res => {
						if(res.code === 200 ){
							console.log('匹配sku绑定仓库商品',res.data)
							this.bindSuccess=res.data.succcessItems
							this.bindError=res.data.errorItems
							this.TppCopy=true
						}
					})
				},

				getFibs(){
					if(this.Fbs){
						console.log(this.chooseStoreId)
						this.getRuler({storeId:this.chooseStoreId})
						.then(res => {
							console.log(res)
							res.forEach(p => {
								p.checked=false
							})
							this.tableData=res
						})

					}
				},
		
				
		
				fixRate(item){
					if(item.rate <=0 || (item.hasVariation ? item.variation.rate <= 0 : false)){
						this.$message.error(this.$t('other.a3020'))
						return
					}
					
					console.log(item)
					item.setRate=false
					if(item.shopee){
						this.updatRate({
							itemId:item.hasVariation ? item.variation.itemId : item.itemId,
							rate:item.hasVariation ? item.variation.rate : item.rate ,
							variationId:item.hasVariation ? item.variation.variationId : 0,
							type:0,
						})
					}
				},
				
				fixItemSku(item){
					console.log(item)
					item.checked01=false
					item.groupName=item.itemSku
					this.updateGroup(item)
				},
				
				// 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
				    beforeUploadFile(file) {
				      // console.log(file)
				      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
				      const size = file.size / 1024 / 1024
				      if (extension !== 'xlsx') {
				        this.$notify.warning({
				          title: this.$t('other.a1507'),
				          message: this.$t('other.a3021')
				        })
				      }
				      if (size > 10) {
				        this.$notify.warning({
				          title: this.$t('other.a1507'),
				          message: this.$t('other.a3022')
				        })
				      }
				    },
				     // 文件状态改变时的钩子
				    fileChange(file, fileList) {
				      // console.log(file)
				      // console.log(fileList)
				    },
				    // 文件超出个数限制时的钩子
				    exceedFile(files, fileList) {
				      this.$notify.warning({
				        title: this.$t('other.a1507'),
				        message: this.$t('other.a2408')+` ${
				          this.limitNum
				        } `+this.$t('other.a2409')+` ${files.length + fileList.length} `+this.$t('other.a1337')
				      })
				    },
				    // 文件上传成功时的钩子
				    handleSuccess(res, file, fileList) {
				      console.log(res)
				     // this.formData.url = res.data  //服务器返回的文件地址
				      this.$message({
				        message: this.$t('other.a3023'),
				        type: 'success'
				      })
				      this.$refs.uploadExcel.clearFiles()// 清楚上次上传记录
				    },
				    // 文件上传失败时的钩子
				    handleError(err, file, fileList) {
				      this.$message.error(err.msg)
				    },
				
				
				importExcel(file) {
				   console.log(file)
				  let params={
					   account:this.userId,
					   file:file,
					   storeId:10100000
				   }
				    console.log(params)
				   this.fileUpload(params)
				},
				
				getmmn(num){
					let ttp=utils.getRecentSevenDay(num)
					let ccp =new Date(ttp)
					return ccp
				},
				//查看仓库的销售情况
				viewStoreSales(item){
					console.log(item)
					let params={
						end:utils.getchinastadarTime(0),
						start:utils.getchinastadarTime(-7),
						userId:this.userId,
						cusCode:item.cusCode
					}
					
					this.getStoreSales(params)
					this.getStoreProductInventoryTurnover(params)
					this.salesItem=params
					this.showSales=true
				},
				//查看仓库库存操作纪录
				viewstoreoperaterecord(item){
					this.instockdia=true
					let params={
						cusCode:item.cusCode,
						end:utils.getchinastadarTime(0),
						start:utils.getchinastadarTime(-7),
						offset:50,
						page:0,
						userId:this.userId
					}
					console.log(params)
					this.getInstockoperaterecore(params)
				},
				//查看仓库产品的订单
				viewGoodsOrder(cusCode) {
					console.log(cusCode)
					this.$router.push({path:'/orders/shopee',query:{cusCode:cusCode}})
				},
				
				getttp(item){
					let arr=[]
					arr.push(item)
					console.log(arr)
					return true
				},
				//开启预售
				autoPre(item){
					console.log(item)
					this.isAutoPre(item)
				},
				fixPresale(item){
					item.setPresale=false
					this.updateIsAutoPre(item)
				},
				
				platform(ttp){
					if(ttp) {
						return 'shopee'
					}else{
						return 'lazada'
					}
				},
				
				conversionShopName(shopId){
					
					let ttp=''
					this.userShops.forEach(p => {
						if(p.shopId === shopId) {
							return ttp=p.shopName
						}
					})
					return ttp
					// return this.warehouseOption.shopId
				},
				conversionSku(item){
					
					let sku=''
					if(item.hasVariation) {
						sku=item.variation.name
					}else{
						sku=item.name
					}
					
					return sku
				},
				
				closeUpdate(item){
				     this.isCloseUpdataBtn=false
					 if(this.tragetList.length){
						 this.tragetList.forEach(p => {
						 	this.userStormList.forEach(k => {
						 		if(p.cusCode == k.cusCode) {
						 			k.synchrony=false
						 		}
						 	})
						 })
						 
						 this.tragetList.forEach(p => {
						 	this.sellerUpdateSynchrony(p)
						 })
					 }else{
						 // this.userStormList.forEach(p =>{
						 // 	if(p.cusCode === this.oooop.cusCode) {
						 // 		console.log(p.cusCode)
						 // 		p.synchrony=false
						 // 	}
						 // })
						 this.oooop.synchrony=false
						 this.sellerUpdateSynchrony(this.oooop)
					 }
					this.dialogVisible01=false
					this.TARGET_ALL(false)
					this.checked_01=false
				},
				closeUpdate_01(){
					this.tragetList=[]
					this.TARGET_ALL(false)
					this.checked_01=false
					this.dialogVisible01=false
				},
				targetAll(){
					if(this.checked_01){
						this.newUserstoreItem.forEach(p => {
							p.checked=true
							
						})
						
					}else{
						this.newUserstoreItem.forEach(p => {
							p.checked=false
						})
					}
					this.targetList=this.newUserstoreItem.filter(p => {
						if(p.checked) {
							return p
						}
					})
					console.log(this.targetList)
					
				},
				piliangenxin(num){
					if(num == 0) {
						this.isOpenUpdataBtn =true
						this.isCloseUpdataBtn=false
						if(!this.targetList.length) {
							this.showMessage(this.$t('userStoreItems').update.text04)
							return
						}
						this.showMessage01(this.$t('userStoreItems').update.text01)
					}else if(num == 1 ) {
						this.isCloseUpdataBtn =true
						this.isOpenUpdataBtn=false
						if(!this.targetList.length) {
							this.showMessage(this.$t('userStoreItems').update.text02)
							return
						}
						this.showMessage01(this.$t('userStoreItems').update.text03)
					}
				
					
				},
				//批量开启自动更新在仓库存
				openUpdate(){
				    if(this.tragetList.length) {
						console.log("批量")
						this.tragetList.forEach(p => {
							this.userStormList.forEach(k => {
								if(p.cusCode == k.cusCode) {
									k.synchrony=true
								}
							})
						})
						
						this.GET_DATA_STATUS_COLSE()
						this.tragetList.forEach(p => {
							this.sellerUpdateSynchrony(p)
						})
						this.TARGET_ALL(false)
						this.checked_01=false
						this.tragetList=[]
					}else{
						console.log("单一")
						this.oooop.synchrony=true
						console.log(this.oooop)
						console.log(this.userStormList)
						this.sellerUpdateSynchrony(this.oooop)
					}
					this.dialogVisible01=false
				},
				
				 updateShopeeItem(item){
					 let count =item.storeNum-item.unShipped
					this.oooop = item
				    let sync = item.synchrony
					item.synchrony=!item.synchrony
					if(sync){
						this.isOpenUpdataBtn=true
						this.isCloseUpdataBtn=false
						this.showMessage01(this.$t('userStoreItems').update.text05 + count + this.$t('userStoreItems').update.text06)
					}else{
						this.isCloseUpdataBtn=true
						this.isOpenUpdataBtn=false
						this.showMessage01(this.$t('userStoreItems').update.text07)
					}
				},
				
				updateShopeeItem007(item){
					console.log(item)
				},
				
				goBindproduct(){
					
					console.log(this.bindItemList01[0].cusCode)
					let curCode=''
					if(this.bindItemList01.length) {
						if(this.bindItemList01[0].hasVariation && this.bindItemList01[0].variation) {
							curCode = this.bindItemList01[0].variation.cusCode
						}
						if(!this.bindItemList01[0].hasVariation){
							curCode = this.bindItemList01[0].cusCode
						}
					}
					this.$router.push({path:'./binditems',query:{cusCode:curCode}})
					console.log(curCode)
					this.dialogTableVisible=false
				},
				
				//搜索商品名称查找
				goTosearch(){
				 this.getShopItems()
				},
				jiebang(item){
					let arr=this.bindItemList01
					if(arr.length === 1) {
						this.showMessage(this.$t('userStoreItems').bindItem.tip)
						return
					}
					this.$confirm(this.$t('other.a209'), this.$t("other.a142"), {
					  confirmButtonText: this.$t('other.a145'),
					  cancelButtonText: this.$t('other.a146'),
					  type: 'warning'
					}).then(() => {
					  
					  this.jiebanItems(item)
					  this.bindItemList01.forEach((p,index)=>{
					  	if(p.hasVariation) {
					  		if(p.variation.itemId == item.variation.itemId && p.variation.variationId == item.variation.variationId  && p.variation.variationSku == item.variation.variationSku) {
					  			this.bindItemList01.splice(index,1)
					  		}
					  	}else{
					  		if(p.categoryId == item.categoryId && p.itemId == item.itemId  && p.itemSku == item.itemSku) {
					  			this.bindItemList01.splice(index,1)
					  		}
					  	}
					  				
					  })
					}).catch(() => {
						
					 
					});
					
				
				},
				deleStoreItem(code) {
					console.log(123)
					let param={
						cusCode:code
					}
					this.deleStoreItems(param)
				},
			
			opendialogTableVisible(item){
				console.log(item)
				this.cuscodeBand=item.cusCode
				this.bindItemList01=item.items
				this.bindItemList02=item.children
				this.dialogTableVisible=true
			},
			//控制每页显示订单条数
			handleSizeChange(val) {
					 console.log(`每页 ${val} 条`);
					 this.offset=parseInt(`${val}`)
					 this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
				  console.log(`${val}`)
						 this.currentPage=parseInt(`${val}`)
						 let ppg=(parseInt(`${val}`) -1) * this.offset
						const params={
							offset:this.offset,
							component: true,
							page:ppg,
							userId:this.userId,
							storeId:this.warehouseId,
							sellerId:this.userId,
							cusCode:''
							
						}
						 console.log(params)
						 this.getStoreItem(params)
			  },
			  stockTotal(num1,num2) {
				  return num1 + num2
			  },
			ttp(){
				console.log(this.warehouse)
				let userInfo=JSON.parse(localStorage.getItem('userInfo'))
				if(userInfo){
					this.secondPws=userInfo.secondPassword
				}
				
				
				
				this.warehouse.forEach(item => {
					let oop={
						label:item.storeId,
						value:item.storeName + "(" + item.userName + ")"
					}
					this.warehouseOption.push(oop)
				})

				this.warehouseId=this.warehouseOption[0].label
				
				this.getShopItems001()
				
			},
			handleEditStreet(index){
				console.log(index)
				this.isEdit =index
				
			},
			confirm(item){
				console.log(item)
				this.sellerUpdateStoreItemDetail(item)
				this.isEdit=-1
			},
			openopenQueHuotixing() {
				this.openQueHuochuankao=true
				
				
			},
			
			changeImgURL(item) {
				return item.image
			},
			getShopNmae(shopId) {
				return this.userShops.find(shop => shop.shopId == shopId).shopName;
			},
			getVariantNmae(row) {
				if (row.variationId == 0 || row.variationId == '') return ""
				return row.item.variations.find(variation => variation.variationId == row.variationId).name;
			},
			addBindToList(item, variation) {
				if (variation == null) {
					variation = {
						variationId: 0
					}
				}
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "shopId", this.shipId);
				this.$set(param, "variation", variation);
				let isInList = false;
				for (let i = 0; i < this.bindItemList.length; i++) {
					if (this.bindItemList[i].itemId == param.itemId) {
						if (!this.bindItemList[i].hasVariation && !param.hasVariation) isInList = true;
						if (this.bindItemList[i].hasVariation && param.hasVariation &&
							this.bindItemList[i].variation.variationId == param.variation.variationId) isInList = true;
					}

				}
				if (!isInList) this.bindItemList.push(param);
				this.itemCount = this.bindItemList.length
				console.log(this.bindItemList)
			},
			commitBind() {
				let param = [];
				for (let i = 0; i < this.bindItemList.length; i++) {
					let binditem = {
						itemId: this.bindItemList[i].itemId,
						shopId: this.bindItemList[i].shopId,
						variationId: this.bindItemList[i].variation.variationId
					}
					param.push(binditem);
				}
				console.log(param);
				api.bindItem(param).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.dialogVisible = true;
						this.visiableMessage = this.$t('other.a2732')
						this.bindTable = false;
					}
				})
			},
			deleteChoose(item,index) {
				this.$confirm(this.$t('other.a2157'), this.$t("other.a142"), {
				  confirmButtonText: this.$t('other.a145'),
				  cancelButtonText: this.$t('other.a146'),
				  type: 'warning'
				}).then(() => {
				  
				  this.userStormList.forEach(p => {
				  	if(p.cusCode === item.cusCode) {
				  		p.checked=false
				  	}
				  })
				  console.log(item)
				  console.log(this.isChooseList)
				  console.log(index)
				  this.isChooseList.splice(index, 1);
				  this.count = this.isChooseList.length;
				  
				 this.newUserstoreItem.forEach(p => {
						p.storeItems.forEach(k => {
							if(item.cusCode == k.cusCode){
								p.checked03=false
								k.checked=false
							}
							
						})
					})


				 
			
				}).catch(() => {
					
				 
				});
				
			},
			handleSelectionChange(val) {
				this.tableData.forEach(p =>{
					if(p.fbsId !== val.fbsId){
						p.checked=false
					}
				})
				
				
				
				
				  
				 
			},
			getShopItems() {
				
				const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					storeId:this.warehouseId,
					sellerId:this.userId,
					cusCode:this.cusCode,
					component: true
				}
				 console.log("选中仓库下的商品",params)
				 this.getStoreItem(params)
			},
			getShopItems001() {
				const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					storeId:this.warehouseId,
					component:true,
					cusCode:''
				}
				 console.log("选中仓库下的商品",params)
				 this.getStoreItem(params)
			},
			updateFromShopee() {
				if (this.selectShop == '') {
					this.showMessage(this.$t('other.a1917'))
				} else {
					api.updateItems(this.selectShop).then(res => {
						if (res.code === 200) {
							this.showMessage(this.$t('other.a1918'))
							this.getShopAllItems(this.selectShop)
						}
					})
				}

			},
			//创建采购单
			createOrder(data) {
				let variantList = [];
				let chooseList = this.isChooseList;
				console.log(chooseList)
				let list=this.tableData.filter(p => {
					if(p.checked){
						return p.fbsId
					}
				})
				console.log('list',list)
				if (chooseList.length == 0) {
					this.showMessage(this.$t('other.a2112'));
					return;
				}else if(!this.value1) {
					this.showMessage(this.$t('other.a2113'));
					return;
				}
				console.log('555',chooseList)
				let dateOfShip=utils.setNowTimes(this.value1).replace(/\s*/g,"");
				for (let i = 0; i < chooseList.length; i++) {
					if (chooseList[i].num == 0 || chooseList[i].num == undefined) {
						this.showMessage(this.$t('other.a2114'));
						return;
					}else if(chooseList[i].storeId !== chooseList[0].storeId) {
						this.showMessage(this.$t('other.a2115'))
						return 
					}
					let variation = {
						anotherName: chooseList[i].anotherName,
						cost: chooseList[i].cost,
						cusCode: chooseList[i].cusCode,
						image: chooseList[i].image,
						itemSku: chooseList[i].itemSku,
						itemName: chooseList[i].itemName,
						variantName: chooseList[i].skuName,
						variantNum: chooseList[i].num,
						variant_id:chooseList[i].variation.variationId ,
						packageHeight:chooseList[i].packageHeight,
						packageLength:chooseList[i].packageLength,
						packageWidth:chooseList[i].packageWidth,
						weight:chooseList[i].weight,
						groupId:chooseList[i].groupId,
					}
					variantList.push(variation);
				}
				let param = {
					messageToSeller: this.sellerMessage,
					storeId: chooseList[0].storeId,
					userId: chooseList[0].userId,
					variantList: variantList,
					dateOfShip:dateOfShip,
					shippingCost:this.shipCost,
					fbs:list.length ? true : null,
					fbsId:list.length ? list[0].fbsId : null
					
			
				}
				console.log('hhh',param)
				
				api.createPurchaseOrder(param)
					.then(res => {
						if (res.code === 200) {
							console.log(res.data)
							this.showMessage(this.$t('userStoreItems').caigoudangtip + res.data.purchaseOrderId);
							this.caigouTable = false;
							this.isChooseList=[]
							this.count=0
							this.value1=''
							this.sellerMessage=''
							this.Fbs=false
							this.userStormList.forEach(p => {
									p.ttp=false
							})
						}else if(res.code === 700){
							this.$message.warning(this.$t('other.a2117'))
						}
				})
			},
			showMessage(massage) {
				this.dialogVisible = true;
				this.visiableMessage = massage;
			},
			showMessage01(massage) {
				this.dialogVisible01 = true;
				this.visiableMessage = massage;
			},
			choseStatus(value) {
				console.log(value)
			},
			handleBtn() {
				console.log(this.bindItemList01)
			},
			getTime(time) {
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp
			},
			getTime01(time){
				return utils.renderTime(time)
			},
			//状态转换
			conversionStatus(ttp) {

				return this.status[ttp]
			},
			unique(arr, type) { // 根据唯一标识orderId来对数组进行过滤
				const res = new Map(); //定义常量 res,值为一个Map对象实例
				//返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
				if (type == 'loupan') {
					return arr.filter((arr) => !res.has(arr.bizid) && res.set(arr.bizid, 1))
				} else {
					return arr.filter((arr) => !res.has(arr.code) && res.set(arr.code, 1))
				}
			},
			tocaiguo(data) {
			
				if(!this.isChooseList.length){
					this.$message.error(this.$t('other.a3024'))
					return

				}
				let storeIdList=this.isChooseList.map(p => {
					return p.storeId
				})
			
				this.chooseStoreId=storeIdList[0]
				this.caigouTable = true;
				if(this.Fbs){
				console.log(this.chooseStoreId)
				this.getRuler({storeId:this.chooseStoreId,userId:this.userId})
				.then(res => {
					console.log(res)
					res.forEach(p => {
						p.checked=false
					})
					this.tableData=res
				})

			}
			},
			tobindItem() {
				this.bindTable = true;
			},
			getALLitems(item){
				item.checked03=!item.checked03
				if(item.checked03){
					item.storeItems.forEach(p => {
						this.isChooseList.forEach((k,index) => {
							if(p.cusCode === k.cusCode) {
								this.isChooseList.splice(index,1)
							}
						})
						
					})
				}
				item.storeItems.forEach(p => {
					!item.checked03 ? p.checked=true : p.checked=false
					this.targetVariation(p,null,1)
				})
				
				
			},
			targetVariation(item, variation,num) {
				

				item.checked=!item.checked
				
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "num", 0);
				this.$set(param, "anotherName", "");
				this.$set(param, "variation", variation == null ? {
					variationId: 0,
					name: '',
					stock: 0
				} : variation)
				let isInList = false;
				for (let i = 0; i < this.isChooseList.length; i++) {
					if (this.isChooseList[i].cusCode === param.cusCode){
						isInList = true;
						this.isChooseList.splice(i,1)
						item.ttp=0
						}
				}
				if (!isInList) this.isChooseList.push(param);
				
				this.KEEP_CHOOSED_ITEM(this.isChooseList)
				this.count = this.isChooseList.length
				console.log('选中需要采购的商品',this.isChooseList)
			},
			cleanForm() {
				this.isChooseList = [];
				this.KEEP_CHOOSED_ITEM(this.isChooseList)
				this.sellerMessage = '';
				this.userStormList.forEach(p => {
						p.ttp=0
				})
				this.count = this.isChooseList.length
			},
			cleanBind() {
				this.bindItemList = [];
			},
			showStore(id){
				let arr=this.options.filter(p => {
					if(p.value == id) {
						return p
					}
				})
				
				return arr[0].label
			},
			
			//成功时弹窗
			 open2(message) {
				 let tip=message
				this.$message({
				  message: tip,
				  type: 'success'
				});
			  },
			  //失败时弹窗
			  open3(message) {
				  let tip=message
				this.$message({
				  message: tip,
				  type: 'warning'
				});
			  },
			  tarCurrent(item){
				  this.tragetList=[]
				  this.userStormList.forEach(p => {
					if(p.checked) {
						this.tragetList.push(p)
					}
				  })
				 
				  console.log('选中',this.tragetList)
			  }
		}
	}
</script>

<style scoped>
	.stroeGoods .demo-table-expand {
		font-size: 0;
	}

	.stroeGoods .demo-table-expand label {
		width: 120px;
		color: #99a9bf;
	}

	.stroeGoods .demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.stroeGoods {
		flex: 1;
		padding: 60px 0 0 221px;
	}

	.stroeGoods .el-dialog__body {
		padding-top: 0px;
	}

	.stroeGoods .list-item {
		justify-content: space-around;
		align-items: center;
		margin: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}

	.stroeGoods .list-variation {
		justify-content: space-around;
		align-items: center;
	}
	
	.goods-title-desc-box{
		margin-right: 20px;
		min-width: 300px;
	}

	.stroeGoods .item-view {
		position: relative;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #E0E0E0;
		box-sizing: border-box;
		padding: 5px 10px 5px 35px;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); */
	}
	
	.goods-title-desc-wrapper{
		display: flex;
	}

	.stroeGoods .variation-list {
		justify-content: space-around;
		align-items: center;
	}

	.stroeGoods .el-collapse-item__content {
		padding: 0rem;
	}

	.stroeGoods .goods-pic {
		width: 80px;
		height: 80px;
	}
	
	.stroeGoods .oook{
		font-size: 20px;
		padding: 0 5px;
	}
	
	.my-goods-data{
		margin-bottom: 50px;
	}

	.stroeGoods .el-dialog__body {
		padding-bottom: 0px !important;
	}

	img {
		width: 100%;
	}
	
	.outPsku{
		height: 50px;
		line-height: 50px;
		/* border-bottom: 1px solid #E3E3E3; */
		font-size: 18px;
		font-weight: bold;
		padding-left: 15px;
		display: flex;
		justify-content: space-between;
	}
	
	.stroeGoods .yihdf{
		display: flex;
	}
	
	.stroeGoods .allChosee{
		padding-left: 20px;
	}

	.stroeGoods .el-dialog__wrapper{
		top:-60px!important;
	}

	.stroeGoods .el-collapse-item__header {

		float: right;
	}

/* 	.stroeGoods .goods-desc {
		display: flex;
		margin-left: 10px;
	} */
	.chekbox{
		position: absolute;
		top: 15px;
		left: 15px;
	}

	.stroeGoods .goods-item {
		
		width: 200px;
		margin: 0px 10px;
		color: #00193A;
	}
	.stroeGoods .goods-btn {
		display: inline-block;
		margin: 7px 10px;
	}
	

	.stroeGoods .goods-title {
		width: 500px;
		color: red;
	}

	.stroeGoods .mygoods-title,
	.query-list {
		display: flex;
		justify-content: space-between;
		margin: 10px;
		padding: 10px;
		border-bottom: 1px #E0E0E0 solid;
	}

	.stroeGoods .shop-choose {
		display: inline-block;
		margin-right: 15px;
	}

	.stroeGoods .create {
		position: relative;
		margin-left: 30px;
	}
	.stroeGoods .xinzhen{
		float: right;
	}

	.stroeGoods .cirlle {
		position: absolute;
		top: -15px;
		left: -13px;
		display: block;
		width: 30px;
		height: 30px;
		background-color: red;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
		color: #fff;
	}
	.storeGoods .goods-title-desc{
		display: flex;
		flex-direction: column;
	}
	.stroeGoods  .mygoods-list-nodata{
		text-align: center;
		margin: 100px;
	}
	.stroeGoods .Pager{
		position: fixed;
		bottom: 0;
		left: 225px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
	.stroeGoods .btn-wrapper{
		display: flex;
		flex-direction: column;
	}
	.stroeGoods .btn-item-desc{
		
		width: 120px;
		margin: 5px 0;
		border: none !important;
	}
	
	.stroeGoods .query-list-bbc{
		display: flex;
		
	}
	
	.stroeGoods .header-top{
		position: fixed;
		width: calc(100% - 221px);
		top: 50px;
		background-color: #fff;
		z-index: 2;
		box-sizing: border-box;
		padding: 0 15px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}
	
	.stroeGoods .mygoods-list{
		margin-top: 160px;
	}
	
	 .stroeGoods .quit-box{
		display: flex;
		justify-content: space-between;
	}
	
	.quit-wrapper-item{
		font-size: 18px;
		width: 50%;
		text-align: center;
	}
	
	.quit-wapper{
		display: flex;
		justify-content: space-between;
		
	}
	
	.ttp-uu{
		text-align: right;
		box-sizing: border-box;
		padding: 10px;
		width: 100%;
	}
	
	.stroeGoods .query-list-tcp{
		display: flex;
		align-items: center;
		padding: 0 0 10px 0;
	}

	
	.visiableMessage_desc{
		line-height: 30px;
	}
	
	.bbp{
		margin-left: 20px;
	}
	
	.el-icon-edit{
		color: #007EE5;
		font-size: 16px;
		cursor: pointer;
		margin-left: 20px;
	}

</style>
